import React from "react"

const AlertIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 18 17" fill="#910A2D">
    <path d="M8.623 0l8.623 16.875H0L8.623 0zm0 3.438L2.559 15.312h12.128L8.623 3.438zM7.842 13.75v-1.563h1.562v1.563H7.842zm0-6.875h1.562V8.75l-.312 2.5h-.938l-.312-2.5V6.875z" id="a" />
  </svg>
)

export default AlertIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/AlertIcon.jsx